<template>
	<textarea :id="id" v-model="redactorValue" :name="name" :placeholder="placeholder"></textarea>
</template>

<script>

// Redactor
require('@/libraries/redactor/redactor.min');
require('@/libraries/redactor/video/video.min');
require('@/libraries/redactor/fullscreen/fullscreen.min');
require('@/libraries/redactor/inlinestyle/inlinestyle.min');

const setExtensions = (state, accountId) => {
	const pluginSlug = `gravityplugin${accountId}`;
	const plugin = {
		init: function(app)
		{
			// define app
			this.app = app;

			// define services
			this.app = app;
			this.lang = app.lang;
			this.opts = app.opts;
			this.toolbar = app.toolbar;
			this.component = app.component;
			this.insertion = app.insertion;
			this.inspector = app.inspector;
		},
		start: function()
		{
			var dropdownData = {};
			state.extensions.forEach(extension => {
				dropdownData[extension.slug] = {
					title: extension.name,
					api: 'plugin.' + pluginSlug + '.' + extension.slug,
				};
			});

			// create the button data
			var buttonData = {
				title: 'Custom',
			};

			// create the button
			// if (!$button) {
			let $button = this.toolbar.getButtons().find(button => button.name === pluginSlug);
			if (!$button) {
				$button = this.toolbar.addButton(pluginSlug, buttonData);
				$button.setIcon('<span class="fal fa-tools"></span>');
			}

			// set dropdown
			var dropdown = $button.setDropdown(dropdownData);
		},
	};

	state.extensions.forEach(extension => {
		plugin[extension.slug] = function() {
			this.insertion.insertHtml(extension.html);
		};
	});

	delete Redactor.plugins[pluginSlug];
	Redactor.add('plugin', pluginSlug, plugin);
};

import { mapGetters } from 'vuex';
import REDACTOR from '@/constants/redactor';

export default {

	props: ['id', 'name', 'module', 'placeholder', 'value', 'buttons', 'plugins', 'format'],

	data() {
		return {
			redactorValue: this.value,
			redactor: null,
			settingOptions: REDACTOR.settings,
		};
	},

	computed: mapGetters(['currentAccount', 'extensions']),

	mounted: function() {
		// $R is defined globally
		// eslint-disable-next-line no-undef
		let plugins = this.getPlugins();

		if (this.extensions.length > 0 && this.format === 'blog') {
			setExtensions(this.$store.state.auth, this.currentAccount.id);
			plugins = [
				...plugins,
				'gravityplugin' + this.currentAccount.id
			];
		}

		this.redactor = new $R(this.$el, {
			plugins: plugins,
			linkNewTab: true,
			imageUpload: '/api/image/upload/' + this.module.slug + '/photos/repository',
			buttons: this.getButtons(),
			breakline: false,
			callbacks: {
				changed: (html) => {
					this.redactorValue = html;
					this.$emit('input', this.redactorValue);
				},
			},
		});
	},

	watch: {

		redactorValue(newValue) {
			this.$emit('input', newValue);
		},

	},

	methods: {
		getButtons() {
			let buttons = this.settingOptions.basic.buttons;

			if (this.hasOwnProperty('buttons') && this.buttons !== null) {
				buttons = this.buttons;
			} else if (typeof this.settingOptions[ this.format ] !== 'undefined') {
				buttons = this.settingOptions[ this.format ].buttons;
			}

			if ((this.$root.isSuperAdmin || this.currentAccount.is_advanced) && buttons.indexOf('html') === -1) {
				buttons = [...buttons, 'html'];
			}

			return buttons;
		},

		getPlugins() {
			if (this.hasOwnProperty('plugins') && this.plugins !== null) {
				return this.plugins;
			}

			if (typeof this.settingOptions[ this.format ] !== 'undefined') {
				return this.settingOptions[ this.format ].plugins;
			}

			return this.settingOptions.basic.plugins;
		},
	},
};

</script>
